class LiteYTEmbed extends HTMLElement {
  connectedCallback() {
    this.videoId = this.getAttribute('videoid');
    
    let playBtnEl = this.querySelector('.lyt-playbtn');
    this.playLabel = (playBtnEl && playBtnEl.textContent.trim()) || this.getAttribute('playlabel') || 'Play';
    
    if (!this.style.backgroundImage) {
      this.style.backgroundImage = `url("https://i.ytimg.com/vi/${this.videoId}/hqdefault.jpg")`;
    }

    if (!playBtnEl) {
      playBtnEl = document.createElement('button');
      playBtnEl.type = 'button';
      playBtnEl.classList.add('lyt-playbtn');
      this.append(playBtnEl);
    }
    playBtnEl.setAttribute('aria-label', this.playLabel);

    this.addEventListener('pointerover', LiteYTEmbed.warmConnections, {once: true});
    this.addEventListener('click', this.addIframe);
  }

  static warmConnections() {
    if (LiteYTEmbed.preconnected) return;
    LiteYTEmbed.preconnected = true;
    const urls = [
      'https://www.youtube-nocookie.com',
      'https://www.google.com',
      'https://googleads.g.doubleclick.net',
      'https://static.doubleclick.net'
    ];
    urls.forEach(url => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = url;
      document.head.append(link);
    });
  }

  addIframe(e) {
    if (this.classList.contains('lyt-activated')) return;
    e.preventDefault();
    this.classList.add('lyt-activated');

    const params = new URLSearchParams(this.getAttribute('params') || '');
    params.append('autoplay', '1');
    params.append('playsinline', '1');

    const iframe = document.createElement('iframe');
    iframe.width = 560;
    iframe.height = 315;
    iframe.title = this.playLabel;
    iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.src = `https://www.youtube-nocookie.com/embed/${this.videoId}?${params.toString()}`;
    this.append(iframe);
  }
}

customElements.define('lite-youtube', LiteYTEmbed);